import script from "./bankDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./bankDrawer.vue?vue&type=script&setup=true&lang=js"

import "./bankDrawer.vue?vue&type=style&index=0&id=aaf91198&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaf91198"]])

export default __exports__